module.exports = __webpack_public_path__ + "img/Disable.eb8ae7ad.svg";